import { z } from "zod";

export const licenseSchema = z
   .object({
      tag: z
         .string()
         .trim()
         .min(1, "O nome da licença é obrigatório."),

      bindingCode: z
         .string()
         .trim()
         .optional(),

      organizationId: z
         .string()
         .min(1, "A organização é obrigatória."),

      initialOwnerUnitId: z
         .string()
         .optional(),

      serialNumber: z
         .string()
         .optional(),

      tokenMqtt: z
         .string()
         .trim()
         .min(1, "O token MQTT é obrigatório."),

      startDate: z
         .string()
         .min(1, "A data de início é obrigatória.")
         .refine(
            (value) => !Number.isNaN(Date.parse(`${value}T00:00:00`)),
            "Data de início inválida."
         ),

      initialDueDate: z
         .string()
         .min(1, "A data de vencimento é obrigatória.")
         .refine(
            (value) => !Number.isNaN(Date.parse(`${value}T00:00:00`)),
            "Data de vencimento inválida."
         ),

      description: z
         .string()
         .trim()
         .optional(),

      type: z
         .string()
         .min(1, "O tipo de licença é obrigatório."),

      features: z
         .array(z.string())
         .optional(),

      period: z
         .string()
         .min(1, "O período de cobrança é obrigatório."),

      amount: z
         .number({
            message: "O valor é obrigatório.",
         })
         .finite("O valor deve ser um número válido.")
         .nonnegative("O valor não pode ser negativo."),

      predictedAmount: z
         .number({
            message: "O valor é obrigatório.",
         })
         .finite("O valor deve ser um número válido.")
         .nonnegative("O valor não pode ser negativo."),

      metadata: z
         .record(z.string(), z.any())
         .optional(),

      automaticRenew: z.boolean(),

      automaticReadjustment: z.boolean(),

      isStartPaid: z.boolean(),

      discountOnAutomaticReadjustment: z
         .string()
         .nullable()
         .optional(),

      paymentMethod: z
         .string()
         .nullable()
         .optional(),

      discountReason: z
         .string()
         .nullable()
         .optional(),
   })
   .superRefine((data, ctx) => {
      const startDate = new Date(`${data.startDate}T00:00:00`);
      const initialDueDate = new Date(
         `${data.initialDueDate}T00:00:00`
      );

      if (initialDueDate < startDate) {
         ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["initialDueDate"],
            message:
               "A data de vencimento deve ser igual ou posterior à data de início.",
         });
      }

      if (data.amount !== data.predictedAmount && !data.discountReason) {
         ctx.addIssue({
            cod: z.ZodIssueCode.custom,
            path: ["discountReason"],
            message: "O motivo de desconto é obrigatório quando o valor difere do previsto."
         });
      }

      if (data.amount === undefined || data.amount === null) {
         ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["amount"],
            message: "O valor é obrigatório.",
         });
      }

      if (data.isStartPaid === true && !data.paymentMethod) {
         ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["paymentMethod"],
            message: "A forma de pagamento é obrigatória.",
         });
      }

      if (data.automaticReadjustment === true && !data.discountOnAutomaticReadjustment) {
         ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["discountOnAutomaticReadjustment"],
            message: "O desconto no reajuste é obrigatório.",
         });
      }
   });